import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Local Business Heroes UK | CRM & Marketing Automation for Local Businesses",
  description = "Rated 4.9/5 by 1,200+ UK businesses. All-in-one CRM and marketing automation. Capture more leads, automate follow-up, grow faster. Start your 14-day trial for just £5.",
  keywords = "CRM UK, marketing automation UK, local business CRM, lead generation software, small business CRM, appointment scheduling software, customer management system, business automation UK",
  image = "https://customer-assets.emergentagent.com/job_localbizheroes/artifacts/792ds0q9_LBH%20Favicon.png",
  url,
  type = "website",
  canonical,
  schemaMarkup,
  breadcrumbs
}) => {
  const siteUrl = "https://localbusinessheroes.net";
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const canonicalUrl = canonical || fullUrl;

  // Combine multiple schema markups
  const allSchemas = [];
  
  if (schemaMarkup) {
    if (Array.isArray(schemaMarkup)) {
      allSchemas.push(...schemaMarkup);
    } else {
      allSchemas.push(schemaMarkup);
    }
  }

  // Add breadcrumbs if provided
  if (breadcrumbs) {
    allSchemas.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": breadcrumbs.map((crumb, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": crumb.name,
        "item": crumb.url ? `${siteUrl}${crumb.url}` : undefined
      }))
    });
  }

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Local Business Heroes" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="language" content="English" />
      <meta name="geo.region" content="GB" />
      <meta name="geo.placename" content="United Kingdom" />
      <meta name="author" content="Local Business Heroes" />

      {/* Schema Markup */}
      {allSchemas.length > 0 && allSchemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
